import type { Feature } from '@/shared/registry'

import { resetPasswordPath } from './paths'

/**
 * Sign-in, and resetting a forgotten password. The callback route, and the sign-in site's pages
 * another site's sign-in and sign-out pass through, are the app's own (`App.tsx`): the callback's
 * path comes from `/config.json`, and the pass-through pages render outside the shell.
 */
export const feature: Feature = {
  id: 'auth',
  routes: [
    {
      path: '/login',
      titleId: 'auth.login.pageTitle',
      page: () => import('./LoginPage').then((module) => module.LoginPage),
      public: true,
    },
    {
      path: resetPasswordPath,
      titleId: 'auth.reset.pageTitle',
      page: () => import('./ResetPasswordPage').then((module) => module.ResetPasswordPage),
      public: true,
    },
  ],
}
